// src/shared_new/components/PerlChip.jsx
import React from "react";
import { Chip, alpha } from "@mui/material";
import { theme } from "../../design/theme";

const perlColors = theme.custom.perlColors;

export default function PerlChip({ label, onDelete, onClick, selected = false, ...props }) {
  return (
    <Chip
      label={label}
      onDelete={onDelete}
      onClick={onClick}
      sx={{
        width: "100%",
        justifyContent: "flex-start",
        height: "auto",
        py: 0.75,
        px: 1.5,
        fontSize: "0.875rem",
        borderRadius: 2,
        border: "2px solid",
        borderColor: selected ? perlColors.brandColor : perlColors.border,
        bgcolor: selected ? alpha(perlColors.brandColor, 0.16) : "transparent",
        color: perlColors.textPrimary,
        "&:hover": {
          bgcolor: selected ? alpha(perlColors.brandColor, 0.22) : alpha(perlColors.white, 0.06),
          borderColor: selected ? perlColors.brandColor : perlColors.border,
        },
        cursor: onClick ? "pointer" : "default",
        ...props.sx,
      }}
      {...props}
    />
  );
}
